import { useToast } from '@chakra-ui/react';
import { useState } from 'react';

import { Draft } from '../../components/RequestDrafts/types';
import { trpc } from '../../config/trpc';

/**
 * Apply the draft's flights to its quote. On success the pane stays on the draft — the point of the applied state is
 * showing WHAT was filled — so this invalidates the queries rather than advancing the list.
 */
export const useApplyDraft = (draft: Draft | undefined): [() => Promise<void>, boolean] => {
  const toast = useToast();
  const utils = trpc.useUtils();
  const [isApplying, setIsApplying] = useState(false);
  const applyRequestDraft = trpc.applyRequestDraft.useMutation();

  const apply = async () => {
    if (!draft) return;
    setIsApplying(true);
    try {
      const summary = await applyRequestDraft.mutateAsync({ id: draft.id });
      toast({
        title: `Applied — ${summary.filled.length} flight${summary.filled.length === 1 ? '' : 's'} filled`,
        description: summary.skipped.length
          ? `${summary.skipped.length} segment(s) skipped — see the draft.`
          : undefined,
        status: 'success',
      });
      await Promise.all([
        utils.getRequestDraft.invalidate({ id: draft.id }),
        utils.getRequestDraftApplyPlan.invalidate({ id: draft.id }),
        utils.getRequestDrafts.invalidate(),
      ]);
    } catch (error) {
      toast({ title: 'Apply failed', description: error?.message, status: 'error' });
    } finally {
      setIsApplying(false);
    }
  };

  return [apply, isApplying];
};
